import {
    Box,
    IconButton,
    TextField,
    Tooltip
} from '@mui/material';
import { GridToolbarFilterButton } from '@mui/x-data-grid';
import { Close, Magnify, Refresh } from 'mdi-material-ui';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';

const GiftshopUseToolbar = props => {
    const { numSelected, selected } = props

    const UpdateReq = () => {
        selected.forEach(async item => {
            try {
                await apiService.put(`/giftshopuse/${item.id}`, {
                    "state": item.state
                })
                toast.success('수정 되었습니다')
            } catch (error) {
                console.error(error)
            }
        })
    }

    return (
        <Box
            sx={{
                p: 2,
                pb: 0,
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                justifyContent: 'space-between'          
            }}
        >
            <Box>
                <GridToolbarFilterButton />
            </Box>
            <Box sx={{ display: 'flex' }}>
            {numSelected > 0 ? (
                <Tooltip title='Update'>
                    <IconButton sx={{ color: '#006A4E' }} onClick={UpdateReq} >
                        <Refresh />
                    </IconButton>
                </Tooltip>
                ) : null}

            <TextField
                variant='standard'
                value={props.value}
                onChange={props.onChange}
                placeholder='사용자ID 검색'
                InputProps={{
                    startAdornment: <Magnify fontSize='small' />,
                    endAdornment: (
                    <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                        <Close fontSize='small' />
                    </IconButton>
                    )
                }}
                sx={{
                    width: {
                        xs: 1,
                        sm: 'auto'
                    },
                    m: theme => theme.spacing(1, 0.5, 1.5),
                    '& .MuiSvgIcon-root': {
                        mr: 0.5
                    },
                    '& .MuiInput-underline:before': {
                        borderBottom: 1,
                        borderColor: 'divider'
                    } 
                }}
            />
            </Box>
        </Box>
    )
}

export default GiftshopUseToolbar